<button mat-stroked-button color="primary" [matMenuTriggerFor]="chipsMenu" class="trigger">
  {{ contracts.length }} engagement(s)
  <mat-icon>arrow_drop_down</mat-icon>
</button>

<mat-menu #chipsMenu="matMenu" class="chips-menu" [overlapTrigger]="false">
  <div class="menu-content">
    <table mat-table [dataSource]="contracts" class="contract-table mat-elevation-z1">
      <!-- Identifiant -->
      <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef>Identifiant</th>
        <td mat-cell *matCellDef="let c">{{ c.technicalIdentifier }}</td>
      </ng-container>

      <!-- Objet de l’engagement -->
      <ng-container matColumnDef="object">
        <th mat-header-cell *matHeaderCellDef>Objet</th>
        <td mat-cell *matCellDef="let c">{{ c.object || '—' }}</td>
      </ng-container>

      <!-- Bouton supprimer -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let c">
          <button
            mat-icon-button
            (click)="removeContract(c); $event.stopPropagation()"
            [permissionBlock]="ENUM_PERMISSIONS.UPDATE_CONTRACT"
            aria-label="Supprimer le contrat"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- En-têtes et lignes -->
      <tr mat-header-row *matHeaderRowDef="['identifier', 'object', 'actions']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['identifier', 'object', 'actions']"></tr>
    </table>
  </div>
</mat-menu>
